import { concat, of, catchError, switchMap, map } from 'rxjs';
import { ofType } from 'redux-observable';
import mapDataSlice from './dataSlice';
import { selectMapResults } from './selectors';
import searchCommunitySitePlansInformation$ from '../apis/searchCommunitySitePlans';
import { processSitePlan } from '../services/processSitePlans';
import SitePlanType from '../enums/sitePlanType';

const actions = mapDataSlice.actions;

const fetchSitePlansEpic = (action$, state$) =>
  action$.pipe(
    ofType(actions.fetchResultsFulfilled.type),
    switchMap(() => {
      const sitePlanCommunityIds = (selectMapResults(state$.value) ?? [])
        .filter((result) => result.sitePlanType && result.sitePlanType !== SitePlanType.None.toString())
        .map((result) => result.communityId);

      return concat(
        of(actions.fetchSitePlans()),
        searchCommunitySitePlansInformation$(sitePlanCommunityIds).pipe(
          map((data) => actions.fetchSitePlansFulfilled(data.map(processSitePlan))),
          catchError((error) => of(actions.fetchSitePlansError(error)))
        )
      );
    })
  );

export default fetchSitePlansEpic;